import React from 'react';
import {connect} from 'react-redux';
import {RadioButton, TextStyle} from '@shopify/polaris';
import classNames from 'classnames';
import Input from './input';
import TextField from './textfield';

class Radio extends Input {
  constructor(props) {
    super(props);

    this.renderOption = this.renderOption.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.renderOtherInput = this.renderOtherInput.bind(this);
  }

  renderOption(option) {
    const {input} = this.props;
    const {error} = input;
    const handleChange = this.handleChange.bind(this, option.value);
    const radioClass = classNames({'sm-input--error': Boolean(error)});

    return (
      <div key={option.value} className={radioClass}>
        <RadioButton
          id={`${input.handle}-${option.value}`}
          name={input.handle}
          label={option.label}
          helpText={this.renderHelpText(option)}
          checked={option.value === input.value}
          onChange={handleChange} // eslint-disable-line react/jsx-no-bind
          error={error}
        />
      </div>
    );
  }

  renderHelpText(option) {
    const otherInput = this.renderOtherInput(option);
    const helpText = option.helpText ? (
      <TextStyle>{option.helpText}</TextStyle>
    ) : null;

    if (otherInput || helpText) {
      return (
        <div>
          {helpText}
          {otherInput}
        </div>
      );
    } else {
      return null;
    }
  }

  renderOtherInput(option) {
    const {input, questionId} = this.props;
    const {otherId} = option;

    if (input.value === option.value && otherId) {
      return <TextField inputId={otherId} questionId={questionId} />;
    }

    return null;
  }

  _render() {
    const {input} = this.props;
    const {options} = input;

    return (
      <div className="sm-question__inputs">
        {options.map(this.renderOption)}
        {this.renderErrorMessage()}
      </div>
    );
  }
}

export default connect(
  Radio.mapStateToProps,
  Radio.mapDispatchToProps
)(Radio);
